import { useMemo } from 'react';

import { collection, doc, DocumentReference } from 'firebase/firestore';

import { useDocumentData } from 'react-firebase-hooks/firestore';

import { ProfileKey } from '../../shared/types/ProfileKey';
import { firestore } from '../firebase';

import { useFirestoreError } from './useFirestoreError';

export interface UseProfileKeysResult {
  profileKeys: ProfileKey | null | undefined;
  isProfileKeysLoading?: boolean;
  profileKeysError?: Error | null;
}

export interface UseProfileKeysProps {
  profileId: string | null | undefined;
}

export default function useProfileKeys(props: UseProfileKeysProps): UseProfileKeysResult {
  const { profileId } = props;

  const profileKeysRef = useMemo(() => {
    if (!profileId) return null;
    const keysCollection = collection(firestore, 'profile', profileId, 'keys');
    const docRef = doc(keysCollection, profileId) as DocumentReference<ProfileKey>;
    return docRef;
  }, [profileId]);

  const [profileKeys, isProfileKeysLoading, profileKeysError] = useDocumentData<ProfileKey>(profileKeysRef);
  useFirestoreError('useProfileKeys', profileKeysError);

  const memoizedResult = useMemo(() => {
    if (!profileId) {
      return {
        profileKeys: null,
        isProfileKeysLoading: false,
        profileKeysError: null,
      };
    }

    return {
      profileKeys: profileKeys || null,
      isProfileKeysLoading,
      profileKeysError,
    };
  }, [profileId, profileKeys, isProfileKeysLoading, profileKeysError]);

  return memoizedResult;
}
